import { ACT_ROL_CHANGE } from "./ActionTypes";
import RolesService from "../provider/rol/RolService";

/*** ACTIONS ROLES ******/
export function actionGetRoles(succesCallback, errorCallback) {
	return (dispatch, getStore) => {
			// loading(true)(dispatch)
			RolesService.getRoles(getStore().app.app).then((response) => {
					dispatch({
							type:ACT_ROL_CHANGE,
							props: {rolList:response}
					})
					succesCallback&&succesCallback()
			}).catch(errorCallback)
			// .finally(()=>{loading(false)(dispatch)})
	};
}

export function actionDeleteRol(rol, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      // loading(true)(dispatch)
      // UserService.deleteUser(getStore().app.app, user.id).then((response) => {
      //   MediaService.deleteFile(user.usrImgPath)  
      //   successCallback()
      // }).catch(errorCallback)
      // .finally(()=>{loading(false)(dispatch)})
  };
}

/****** FIN ACTION ROLES +**********/


// WEBPACK FOOTER //
// ./src/actions/RolActions.js